import { styled } from "@mui/material/styles";

const styledName = "ResetPasswordForm";

export const StyledInputWrapper = styled("div", { name: styledName })({
  "&": {
    marginBottom: "30px",
  },
});
